import React from 'react';

export const COGNITO_USER_POOL_ID = process.env.GATSBY_COGNITO_USER_POOL_ID;
export const COGNITO_CLIENT_ID = process.env.GATSBY_COGNITO_CLIENT_ID;
